import { ClickTracker } from 'bernie-analytics';
import { UitkRadio, UitkCheckbox, UitkFavoriteSwitch } from 'uitk-react-switch';
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton, UitkOverlayButton } from 'uitk-react-button';
import { UitkFakeInput } from 'uitk-react-input';
import { Link } from 'react-router-dom';
import { UitkImageLink } from 'uitk-react-images';
import { ActivitySpannedTileCard } from '../components/srp/modules/module-components/simple-result-card';

const ANCHOR = 'a';
const BUTTON = 'button';

export const CheckboxTracked = ClickTracker(UitkCheckbox);
export const TertiaryButtonTracked = ClickTracker(UitkTertiaryButton);
export const RadioButtonTracked = ClickTracker(UitkRadio);
export const PrimaryButtonTracked = ClickTracker(UitkPrimaryButton);
export const SecondaryButtonTracked = ClickTracker(UitkSecondaryButton);
export const LinkTracked = ClickTracker(Link);
export const TrackedActivitySpannedTileCard = ClickTracker(ActivitySpannedTileCard);
export const FakeInputTracked = ClickTracker(UitkFakeInput);
export const AnchorTracked = ClickTracker(ANCHOR);
export const FavoriteSwitchTracked = ClickTracker(UitkFavoriteSwitch);
export const ImageLinkTracked = ClickTracker(UitkImageLink);
export const ButtonTracked = ClickTracker(BUTTON);
export const OverlayButtonTracked = ClickTracker(UitkOverlayButton);
